var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch",class:{ 'on': _vm.isOn },on:{"click":_vm.toggleSwitch}})
}
var staticRenderFns = []

export { render, staticRenderFns }